/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as NotFoundImport } from './routes/not-found'
import { Route as ContactUsImport } from './routes/contact-us'
import { Route as AccessDeniedImport } from './routes/access-denied'
import { Route as HomeImport } from './routes/_home'
import { Route as AuthImport } from './routes/_auth'
import { Route as HomeIndexImport } from './routes/_home/index'
import { Route as HomeTrackingImport } from './routes/_home/tracking'
import { Route as HomeReportsImport } from './routes/_home/reports'
import { Route as HomeMapImport } from './routes/_home/map'
import { Route as HomeDashboardImport } from './routes/_home/dashboard'
import { Route as HomeBillingAdjustmentImport } from './routes/_home/billing-adjustment'
import { Route as HomeBillingImport } from './routes/_home/billing'
import { Route as AuthUnknownDeviceImport } from './routes/_auth/unknown-device'
import { Route as AuthTrustDeviceImport } from './routes/_auth/trust-device'
import { Route as AuthMfaAuthImport } from './routes/_auth/mfa-auth'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as HomeMeterInfoIndexImport } from './routes/_home/meter-info/index'
import { Route as HomeManageConsumersIndexImport } from './routes/_home/manage-consumers/index'
import { Route as HomeAnnouncementIndexImport } from './routes/_home/announcement/index'
import { Route as HomeAnalyticsIndexImport } from './routes/_home/analytics/index'
import { Route as HomeSettingsProfileImport } from './routes/_home/settings/profile'
import { Route as HomeSettingsChangePasswordImport } from './routes/_home/settings/change-password'
import { Route as HomeMeterInfoAddImport } from './routes/_home/meter-info/add'
import { Route as HomeManageConsumersAddServiceRequestImport } from './routes/_home/manage-consumers/add-service-request'
import { Route as HomeManageConsumersAddImport } from './routes/_home/manage-consumers/add'
import { Route as HomeAnnouncementOverallAnnouncementImport } from './routes/_home/announcement/overall-announcement'
import { Route as HomeZoneSettingsZonesIndexImport } from './routes/_home/zone-settings/zones/index'
import { Route as HomeZoneSettingsZonePolicyDueDateIndexImport } from './routes/_home/zone-settings/zone-policy-due-date/index'
import { Route as HomeZoneSettingsZoneConnectionRatesIndexImport } from './routes/_home/zone-settings/zone-connection-rates/index'
import { Route as HomeZoneSettingsBooksZoneIndexImport } from './routes/_home/zone-settings/books-zone/index'
import { Route as HomeUserRoleManagementPositionIndexImport } from './routes/_home/user-role-management/position/index'
import { Route as HomeUserRoleManagementDepartmentIndexImport } from './routes/_home/user-role-management/department/index'
import { Route as HomeUserRoleManagementBillingUserInfoIndexImport } from './routes/_home/user-role-management/billing-user-info/index'
import { Route as HomeSystemConfigAnnouncementIndexImport } from './routes/_home/system-config/announcement/index'
import { Route as HomeMeterConnectionSettingsMeterStatusIndexImport } from './routes/_home/meter-connection-settings/meter-status/index'
import { Route as HomeMeterConnectionSettingsMeterSizeIndexImport } from './routes/_home/meter-connection-settings/meter-size/index'
import { Route as HomeMeterConnectionSettingsMeterSizeRatesIndexImport } from './routes/_home/meter-connection-settings/meter-size-rates/index'
import { Route as HomeMeterConnectionSettingsMeterReaderIndexImport } from './routes/_home/meter-connection-settings/meter-reader/index'
import { Route as HomeMeterConnectionSettingsConnectionTypeIndexImport } from './routes/_home/meter-connection-settings/connection-type/index'
import { Route as HomeMeterConnectionSettingsConnectionStatusIndexImport } from './routes/_home/meter-connection-settings/connection-status/index'
import { Route as HomeMeterConnectionSettingsCommodityRatesIndexImport } from './routes/_home/meter-connection-settings/commodity-rates/index'
import { Route as HomeMessageTemplatesSmsIndexImport } from './routes/_home/message-templates/sms/index'
import { Route as HomeMessageTemplatesEmailIndexImport } from './routes/_home/message-templates/email/index'
import { Route as HomeZoneSettingsZonesEditImport } from './routes/_home/zone-settings/zones/edit'
import { Route as HomeZoneSettingsZonesAddImport } from './routes/_home/zone-settings/zones/add'
import { Route as HomeZoneSettingsZonePolicyDueDateEditImport } from './routes/_home/zone-settings/zone-policy-due-date/edit'
import { Route as HomeZoneSettingsZonePolicyDueDateAddImport } from './routes/_home/zone-settings/zone-policy-due-date/add'
import { Route as HomeZoneSettingsZoneConnectionRatesAddImport } from './routes/_home/zone-settings/zone-connection-rates/add'
import { Route as HomeZoneSettingsBooksZoneAddImport } from './routes/_home/zone-settings/books-zone/add'
import { Route as HomeUserRoleManagementPositionEditImport } from './routes/_home/user-role-management/position/edit'
import { Route as HomeUserRoleManagementPositionAddImport } from './routes/_home/user-role-management/position/add'
import { Route as HomeUserRoleManagementDepartmentEditImport } from './routes/_home/user-role-management/department/edit'
import { Route as HomeUserRoleManagementDepartmentAddImport } from './routes/_home/user-role-management/department/add'
import { Route as HomeUserRoleManagementBillingUserInfoEditImport } from './routes/_home/user-role-management/billing-user-info/edit'
import { Route as HomeUserRoleManagementBillingUserInfoAddImport } from './routes/_home/user-role-management/billing-user-info/add'
import { Route as HomeMeterConnectionSettingsMeterStatusEditImport } from './routes/_home/meter-connection-settings/meter-status/edit'
import { Route as HomeMeterConnectionSettingsMeterStatusAddImport } from './routes/_home/meter-connection-settings/meter-status/add'
import { Route as HomeMeterConnectionSettingsMeterSizeAddImport } from './routes/_home/meter-connection-settings/meter-size/add'
import { Route as HomeMeterConnectionSettingsMeterSizeRatesAddImport } from './routes/_home/meter-connection-settings/meter-size-rates/add'
import { Route as HomeMeterConnectionSettingsMeterReaderAddImport } from './routes/_home/meter-connection-settings/meter-reader/add'
import { Route as HomeMeterConnectionSettingsConnectionTypeEditImport } from './routes/_home/meter-connection-settings/connection-type/edit'
import { Route as HomeMeterConnectionSettingsConnectionTypeAddImport } from './routes/_home/meter-connection-settings/connection-type/add'
import { Route as HomeMeterConnectionSettingsConnectionStatusEditImport } from './routes/_home/meter-connection-settings/connection-status/edit'
import { Route as HomeMeterConnectionSettingsConnectionStatusAddImport } from './routes/_home/meter-connection-settings/connection-status/add'
import { Route as HomeMessageTemplatesSmsEditImport } from './routes/_home/message-templates/sms/edit'
import { Route as HomeMessageTemplatesSmsAddImport } from './routes/_home/message-templates/sms/add'
import { Route as HomeMessageTemplatesEmailEditImport } from './routes/_home/message-templates/email/edit'
import { Route as HomeMessageTemplatesEmailAddImport } from './routes/_home/message-templates/email/add'
import { Route as HomeManageConsumersViewServiceRequestHistoryIdImport } from './routes/_home/manage-consumers/view-service-request-history.$id'
import { Route as HomeManageConsumersViewPaymentHistoryIdImport } from './routes/_home/manage-consumers/view-payment-history.$id'
import { Route as HomeManageConsumersViewConsumptionHistoryIdImport } from './routes/_home/manage-consumers/view-consumption-history.$id'
import { Route as HomeManageConsumersViewBillingHistoryIdImport } from './routes/_home/manage-consumers/view-billing-history.$id'
import { Route as HomeManageConsumersEditIdImport } from './routes/_home/manage-consumers/edit.$id'
import { Route as HomeZoneSettingsZoneConnectionRatesEditIdImport } from './routes/_home/zone-settings/zone-connection-rates/edit.$id'
import { Route as HomeZoneSettingsBooksZoneEditIdImport } from './routes/_home/zone-settings/books-zone/edit.$id'
import { Route as HomeMeterConnectionSettingsMeterSizeEditIdImport } from './routes/_home/meter-connection-settings/meter-size/edit.$id'
import { Route as HomeMeterConnectionSettingsMeterReaderEditIdImport } from './routes/_home/meter-connection-settings/meter-reader/edit.$id'

// Create/Update Routes

const NotFoundRoute = NotFoundImport.update({
  path: '/not-found',
  getParentRoute: () => rootRoute,
} as any)

const ContactUsRoute = ContactUsImport.update({
  path: '/contact-us',
  getParentRoute: () => rootRoute,
} as any)

const AccessDeniedRoute = AccessDeniedImport.update({
  path: '/access-denied',
  getParentRoute: () => rootRoute,
} as any)

const HomeRoute = HomeImport.update({
  id: '/_home',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const HomeIndexRoute = HomeIndexImport.update({
  path: '/',
  getParentRoute: () => HomeRoute,
} as any)

const HomeTrackingRoute = HomeTrackingImport.update({
  path: '/tracking',
  getParentRoute: () => HomeRoute,
} as any)

const HomeReportsRoute = HomeReportsImport.update({
  path: '/reports',
  getParentRoute: () => HomeRoute,
} as any)

const HomeMapRoute = HomeMapImport.update({
  path: '/map',
  getParentRoute: () => HomeRoute,
} as any)

const HomeDashboardRoute = HomeDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => HomeRoute,
} as any)

const HomeBillingAdjustmentRoute = HomeBillingAdjustmentImport.update({
  path: '/billing-adjustment',
  getParentRoute: () => HomeRoute,
} as any)

const HomeBillingRoute = HomeBillingImport.update({
  path: '/billing',
  getParentRoute: () => HomeRoute,
} as any)

const AuthUnknownDeviceRoute = AuthUnknownDeviceImport.update({
  path: '/unknown-device',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTrustDeviceRoute = AuthTrustDeviceImport.update({
  path: '/trust-device',
  getParentRoute: () => AuthRoute,
} as any)

const AuthMfaAuthRoute = AuthMfaAuthImport.update({
  path: '/mfa-auth',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const HomeMeterInfoIndexRoute = HomeMeterInfoIndexImport.update({
  path: '/meter-info/',
  getParentRoute: () => HomeRoute,
} as any)

const HomeManageConsumersIndexRoute = HomeManageConsumersIndexImport.update({
  path: '/manage-consumers/',
  getParentRoute: () => HomeRoute,
} as any)

const HomeAnnouncementIndexRoute = HomeAnnouncementIndexImport.update({
  path: '/announcement/',
  getParentRoute: () => HomeRoute,
} as any)

const HomeAnalyticsIndexRoute = HomeAnalyticsIndexImport.update({
  path: '/analytics/',
  getParentRoute: () => HomeRoute,
} as any)

const HomeSettingsProfileRoute = HomeSettingsProfileImport.update({
  path: '/settings/profile',
  getParentRoute: () => HomeRoute,
} as any)

const HomeSettingsChangePasswordRoute = HomeSettingsChangePasswordImport.update(
  {
    path: '/settings/change-password',
    getParentRoute: () => HomeRoute,
  } as any,
)

const HomeMeterInfoAddRoute = HomeMeterInfoAddImport.update({
  path: '/meter-info/add',
  getParentRoute: () => HomeRoute,
} as any)

const HomeManageConsumersAddServiceRequestRoute =
  HomeManageConsumersAddServiceRequestImport.update({
    path: '/manage-consumers/add-service-request',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeManageConsumersAddRoute = HomeManageConsumersAddImport.update({
  path: '/manage-consumers/add',
  getParentRoute: () => HomeRoute,
} as any)

const HomeAnnouncementOverallAnnouncementRoute =
  HomeAnnouncementOverallAnnouncementImport.update({
    path: '/announcement/overall-announcement',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsZonesIndexRoute = HomeZoneSettingsZonesIndexImport.update(
  {
    path: '/zone-settings/zones/',
    getParentRoute: () => HomeRoute,
  } as any,
)

const HomeZoneSettingsZonePolicyDueDateIndexRoute =
  HomeZoneSettingsZonePolicyDueDateIndexImport.update({
    path: '/zone-settings/zone-policy-due-date/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsZoneConnectionRatesIndexRoute =
  HomeZoneSettingsZoneConnectionRatesIndexImport.update({
    path: '/zone-settings/zone-connection-rates/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsBooksZoneIndexRoute =
  HomeZoneSettingsBooksZoneIndexImport.update({
    path: '/zone-settings/books-zone/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementPositionIndexRoute =
  HomeUserRoleManagementPositionIndexImport.update({
    path: '/user-role-management/position/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementDepartmentIndexRoute =
  HomeUserRoleManagementDepartmentIndexImport.update({
    path: '/user-role-management/department/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementBillingUserInfoIndexRoute =
  HomeUserRoleManagementBillingUserInfoIndexImport.update({
    path: '/user-role-management/billing-user-info/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeSystemConfigAnnouncementIndexRoute =
  HomeSystemConfigAnnouncementIndexImport.update({
    path: '/system-config/announcement/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterStatusIndexRoute =
  HomeMeterConnectionSettingsMeterStatusIndexImport.update({
    path: '/meter-connection-settings/meter-status/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterSizeIndexRoute =
  HomeMeterConnectionSettingsMeterSizeIndexImport.update({
    path: '/meter-connection-settings/meter-size/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterSizeRatesIndexRoute =
  HomeMeterConnectionSettingsMeterSizeRatesIndexImport.update({
    path: '/meter-connection-settings/meter-size-rates/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterReaderIndexRoute =
  HomeMeterConnectionSettingsMeterReaderIndexImport.update({
    path: '/meter-connection-settings/meter-reader/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsConnectionTypeIndexRoute =
  HomeMeterConnectionSettingsConnectionTypeIndexImport.update({
    path: '/meter-connection-settings/connection-type/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsConnectionStatusIndexRoute =
  HomeMeterConnectionSettingsConnectionStatusIndexImport.update({
    path: '/meter-connection-settings/connection-status/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsCommodityRatesIndexRoute =
  HomeMeterConnectionSettingsCommodityRatesIndexImport.update({
    path: '/meter-connection-settings/commodity-rates/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMessageTemplatesSmsIndexRoute =
  HomeMessageTemplatesSmsIndexImport.update({
    path: '/message-templates/sms/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMessageTemplatesEmailIndexRoute =
  HomeMessageTemplatesEmailIndexImport.update({
    path: '/message-templates/email/',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsZonesEditRoute = HomeZoneSettingsZonesEditImport.update({
  path: '/zone-settings/zones/edit',
  getParentRoute: () => HomeRoute,
} as any)

const HomeZoneSettingsZonesAddRoute = HomeZoneSettingsZonesAddImport.update({
  path: '/zone-settings/zones/add',
  getParentRoute: () => HomeRoute,
} as any)

const HomeZoneSettingsZonePolicyDueDateEditRoute =
  HomeZoneSettingsZonePolicyDueDateEditImport.update({
    path: '/zone-settings/zone-policy-due-date/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsZonePolicyDueDateAddRoute =
  HomeZoneSettingsZonePolicyDueDateAddImport.update({
    path: '/zone-settings/zone-policy-due-date/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsZoneConnectionRatesAddRoute =
  HomeZoneSettingsZoneConnectionRatesAddImport.update({
    path: '/zone-settings/zone-connection-rates/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsBooksZoneAddRoute =
  HomeZoneSettingsBooksZoneAddImport.update({
    path: '/zone-settings/books-zone/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementPositionEditRoute =
  HomeUserRoleManagementPositionEditImport.update({
    path: '/user-role-management/position/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementPositionAddRoute =
  HomeUserRoleManagementPositionAddImport.update({
    path: '/user-role-management/position/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementDepartmentEditRoute =
  HomeUserRoleManagementDepartmentEditImport.update({
    path: '/user-role-management/department/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementDepartmentAddRoute =
  HomeUserRoleManagementDepartmentAddImport.update({
    path: '/user-role-management/department/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementBillingUserInfoEditRoute =
  HomeUserRoleManagementBillingUserInfoEditImport.update({
    path: '/user-role-management/billing-user-info/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeUserRoleManagementBillingUserInfoAddRoute =
  HomeUserRoleManagementBillingUserInfoAddImport.update({
    path: '/user-role-management/billing-user-info/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterStatusEditRoute =
  HomeMeterConnectionSettingsMeterStatusEditImport.update({
    path: '/meter-connection-settings/meter-status/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterStatusAddRoute =
  HomeMeterConnectionSettingsMeterStatusAddImport.update({
    path: '/meter-connection-settings/meter-status/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterSizeAddRoute =
  HomeMeterConnectionSettingsMeterSizeAddImport.update({
    path: '/meter-connection-settings/meter-size/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterSizeRatesAddRoute =
  HomeMeterConnectionSettingsMeterSizeRatesAddImport.update({
    path: '/meter-connection-settings/meter-size-rates/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterReaderAddRoute =
  HomeMeterConnectionSettingsMeterReaderAddImport.update({
    path: '/meter-connection-settings/meter-reader/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsConnectionTypeEditRoute =
  HomeMeterConnectionSettingsConnectionTypeEditImport.update({
    path: '/meter-connection-settings/connection-type/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsConnectionTypeAddRoute =
  HomeMeterConnectionSettingsConnectionTypeAddImport.update({
    path: '/meter-connection-settings/connection-type/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsConnectionStatusEditRoute =
  HomeMeterConnectionSettingsConnectionStatusEditImport.update({
    path: '/meter-connection-settings/connection-status/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsConnectionStatusAddRoute =
  HomeMeterConnectionSettingsConnectionStatusAddImport.update({
    path: '/meter-connection-settings/connection-status/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMessageTemplatesSmsEditRoute =
  HomeMessageTemplatesSmsEditImport.update({
    path: '/message-templates/sms/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMessageTemplatesSmsAddRoute = HomeMessageTemplatesSmsAddImport.update(
  {
    path: '/message-templates/sms/add',
    getParentRoute: () => HomeRoute,
  } as any,
)

const HomeMessageTemplatesEmailEditRoute =
  HomeMessageTemplatesEmailEditImport.update({
    path: '/message-templates/email/edit',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMessageTemplatesEmailAddRoute =
  HomeMessageTemplatesEmailAddImport.update({
    path: '/message-templates/email/add',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeManageConsumersViewServiceRequestHistoryIdRoute =
  HomeManageConsumersViewServiceRequestHistoryIdImport.update({
    path: '/manage-consumers/view-service-request-history/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeManageConsumersViewPaymentHistoryIdRoute =
  HomeManageConsumersViewPaymentHistoryIdImport.update({
    path: '/manage-consumers/view-payment-history/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeManageConsumersViewConsumptionHistoryIdRoute =
  HomeManageConsumersViewConsumptionHistoryIdImport.update({
    path: '/manage-consumers/view-consumption-history/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeManageConsumersViewBillingHistoryIdRoute =
  HomeManageConsumersViewBillingHistoryIdImport.update({
    path: '/manage-consumers/view-billing-history/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeManageConsumersEditIdRoute = HomeManageConsumersEditIdImport.update({
  path: '/manage-consumers/edit/$id',
  getParentRoute: () => HomeRoute,
} as any)

const HomeZoneSettingsZoneConnectionRatesEditIdRoute =
  HomeZoneSettingsZoneConnectionRatesEditIdImport.update({
    path: '/zone-settings/zone-connection-rates/edit/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeZoneSettingsBooksZoneEditIdRoute =
  HomeZoneSettingsBooksZoneEditIdImport.update({
    path: '/zone-settings/books-zone/edit/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterSizeEditIdRoute =
  HomeMeterConnectionSettingsMeterSizeEditIdImport.update({
    path: '/meter-connection-settings/meter-size/edit/$id',
    getParentRoute: () => HomeRoute,
  } as any)

const HomeMeterConnectionSettingsMeterReaderEditIdRoute =
  HomeMeterConnectionSettingsMeterReaderEditIdImport.update({
    path: '/meter-connection-settings/meter-reader/edit/$id',
    getParentRoute: () => HomeRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_home': {
      id: '/_home'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof HomeImport
      parentRoute: typeof rootRoute
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedImport
      parentRoute: typeof rootRoute
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsImport
      parentRoute: typeof rootRoute
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/mfa-auth': {
      id: '/_auth/mfa-auth'
      path: '/mfa-auth'
      fullPath: '/mfa-auth'
      preLoaderRoute: typeof AuthMfaAuthImport
      parentRoute: typeof AuthImport
    }
    '/_auth/trust-device': {
      id: '/_auth/trust-device'
      path: '/trust-device'
      fullPath: '/trust-device'
      preLoaderRoute: typeof AuthTrustDeviceImport
      parentRoute: typeof AuthImport
    }
    '/_auth/unknown-device': {
      id: '/_auth/unknown-device'
      path: '/unknown-device'
      fullPath: '/unknown-device'
      preLoaderRoute: typeof AuthUnknownDeviceImport
      parentRoute: typeof AuthImport
    }
    '/_home/billing': {
      id: '/_home/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof HomeBillingImport
      parentRoute: typeof HomeImport
    }
    '/_home/billing-adjustment': {
      id: '/_home/billing-adjustment'
      path: '/billing-adjustment'
      fullPath: '/billing-adjustment'
      preLoaderRoute: typeof HomeBillingAdjustmentImport
      parentRoute: typeof HomeImport
    }
    '/_home/dashboard': {
      id: '/_home/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof HomeDashboardImport
      parentRoute: typeof HomeImport
    }
    '/_home/map': {
      id: '/_home/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof HomeMapImport
      parentRoute: typeof HomeImport
    }
    '/_home/reports': {
      id: '/_home/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof HomeReportsImport
      parentRoute: typeof HomeImport
    }
    '/_home/tracking': {
      id: '/_home/tracking'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof HomeTrackingImport
      parentRoute: typeof HomeImport
    }
    '/_home/': {
      id: '/_home/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof HomeIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/announcement/overall-announcement': {
      id: '/_home/announcement/overall-announcement'
      path: '/announcement/overall-announcement'
      fullPath: '/announcement/overall-announcement'
      preLoaderRoute: typeof HomeAnnouncementOverallAnnouncementImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/add': {
      id: '/_home/manage-consumers/add'
      path: '/manage-consumers/add'
      fullPath: '/manage-consumers/add'
      preLoaderRoute: typeof HomeManageConsumersAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/add-service-request': {
      id: '/_home/manage-consumers/add-service-request'
      path: '/manage-consumers/add-service-request'
      fullPath: '/manage-consumers/add-service-request'
      preLoaderRoute: typeof HomeManageConsumersAddServiceRequestImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-info/add': {
      id: '/_home/meter-info/add'
      path: '/meter-info/add'
      fullPath: '/meter-info/add'
      preLoaderRoute: typeof HomeMeterInfoAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/settings/change-password': {
      id: '/_home/settings/change-password'
      path: '/settings/change-password'
      fullPath: '/settings/change-password'
      preLoaderRoute: typeof HomeSettingsChangePasswordImport
      parentRoute: typeof HomeImport
    }
    '/_home/settings/profile': {
      id: '/_home/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof HomeSettingsProfileImport
      parentRoute: typeof HomeImport
    }
    '/_home/analytics/': {
      id: '/_home/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof HomeAnalyticsIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/announcement/': {
      id: '/_home/announcement/'
      path: '/announcement'
      fullPath: '/announcement'
      preLoaderRoute: typeof HomeAnnouncementIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/': {
      id: '/_home/manage-consumers/'
      path: '/manage-consumers'
      fullPath: '/manage-consumers'
      preLoaderRoute: typeof HomeManageConsumersIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-info/': {
      id: '/_home/meter-info/'
      path: '/meter-info'
      fullPath: '/meter-info'
      preLoaderRoute: typeof HomeMeterInfoIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/edit/$id': {
      id: '/_home/manage-consumers/edit/$id'
      path: '/manage-consumers/edit/$id'
      fullPath: '/manage-consumers/edit/$id'
      preLoaderRoute: typeof HomeManageConsumersEditIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/view-billing-history/$id': {
      id: '/_home/manage-consumers/view-billing-history/$id'
      path: '/manage-consumers/view-billing-history/$id'
      fullPath: '/manage-consumers/view-billing-history/$id'
      preLoaderRoute: typeof HomeManageConsumersViewBillingHistoryIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/view-consumption-history/$id': {
      id: '/_home/manage-consumers/view-consumption-history/$id'
      path: '/manage-consumers/view-consumption-history/$id'
      fullPath: '/manage-consumers/view-consumption-history/$id'
      preLoaderRoute: typeof HomeManageConsumersViewConsumptionHistoryIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/view-payment-history/$id': {
      id: '/_home/manage-consumers/view-payment-history/$id'
      path: '/manage-consumers/view-payment-history/$id'
      fullPath: '/manage-consumers/view-payment-history/$id'
      preLoaderRoute: typeof HomeManageConsumersViewPaymentHistoryIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/manage-consumers/view-service-request-history/$id': {
      id: '/_home/manage-consumers/view-service-request-history/$id'
      path: '/manage-consumers/view-service-request-history/$id'
      fullPath: '/manage-consumers/view-service-request-history/$id'
      preLoaderRoute: typeof HomeManageConsumersViewServiceRequestHistoryIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/message-templates/email/add': {
      id: '/_home/message-templates/email/add'
      path: '/message-templates/email/add'
      fullPath: '/message-templates/email/add'
      preLoaderRoute: typeof HomeMessageTemplatesEmailAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/message-templates/email/edit': {
      id: '/_home/message-templates/email/edit'
      path: '/message-templates/email/edit'
      fullPath: '/message-templates/email/edit'
      preLoaderRoute: typeof HomeMessageTemplatesEmailEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/message-templates/sms/add': {
      id: '/_home/message-templates/sms/add'
      path: '/message-templates/sms/add'
      fullPath: '/message-templates/sms/add'
      preLoaderRoute: typeof HomeMessageTemplatesSmsAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/message-templates/sms/edit': {
      id: '/_home/message-templates/sms/edit'
      path: '/message-templates/sms/edit'
      fullPath: '/message-templates/sms/edit'
      preLoaderRoute: typeof HomeMessageTemplatesSmsEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/connection-status/add': {
      id: '/_home/meter-connection-settings/connection-status/add'
      path: '/meter-connection-settings/connection-status/add'
      fullPath: '/meter-connection-settings/connection-status/add'
      preLoaderRoute: typeof HomeMeterConnectionSettingsConnectionStatusAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/connection-status/edit': {
      id: '/_home/meter-connection-settings/connection-status/edit'
      path: '/meter-connection-settings/connection-status/edit'
      fullPath: '/meter-connection-settings/connection-status/edit'
      preLoaderRoute: typeof HomeMeterConnectionSettingsConnectionStatusEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/connection-type/add': {
      id: '/_home/meter-connection-settings/connection-type/add'
      path: '/meter-connection-settings/connection-type/add'
      fullPath: '/meter-connection-settings/connection-type/add'
      preLoaderRoute: typeof HomeMeterConnectionSettingsConnectionTypeAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/connection-type/edit': {
      id: '/_home/meter-connection-settings/connection-type/edit'
      path: '/meter-connection-settings/connection-type/edit'
      fullPath: '/meter-connection-settings/connection-type/edit'
      preLoaderRoute: typeof HomeMeterConnectionSettingsConnectionTypeEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-reader/add': {
      id: '/_home/meter-connection-settings/meter-reader/add'
      path: '/meter-connection-settings/meter-reader/add'
      fullPath: '/meter-connection-settings/meter-reader/add'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterReaderAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-size-rates/add': {
      id: '/_home/meter-connection-settings/meter-size-rates/add'
      path: '/meter-connection-settings/meter-size-rates/add'
      fullPath: '/meter-connection-settings/meter-size-rates/add'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterSizeRatesAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-size/add': {
      id: '/_home/meter-connection-settings/meter-size/add'
      path: '/meter-connection-settings/meter-size/add'
      fullPath: '/meter-connection-settings/meter-size/add'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterSizeAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-status/add': {
      id: '/_home/meter-connection-settings/meter-status/add'
      path: '/meter-connection-settings/meter-status/add'
      fullPath: '/meter-connection-settings/meter-status/add'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterStatusAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-status/edit': {
      id: '/_home/meter-connection-settings/meter-status/edit'
      path: '/meter-connection-settings/meter-status/edit'
      fullPath: '/meter-connection-settings/meter-status/edit'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterStatusEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/billing-user-info/add': {
      id: '/_home/user-role-management/billing-user-info/add'
      path: '/user-role-management/billing-user-info/add'
      fullPath: '/user-role-management/billing-user-info/add'
      preLoaderRoute: typeof HomeUserRoleManagementBillingUserInfoAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/billing-user-info/edit': {
      id: '/_home/user-role-management/billing-user-info/edit'
      path: '/user-role-management/billing-user-info/edit'
      fullPath: '/user-role-management/billing-user-info/edit'
      preLoaderRoute: typeof HomeUserRoleManagementBillingUserInfoEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/department/add': {
      id: '/_home/user-role-management/department/add'
      path: '/user-role-management/department/add'
      fullPath: '/user-role-management/department/add'
      preLoaderRoute: typeof HomeUserRoleManagementDepartmentAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/department/edit': {
      id: '/_home/user-role-management/department/edit'
      path: '/user-role-management/department/edit'
      fullPath: '/user-role-management/department/edit'
      preLoaderRoute: typeof HomeUserRoleManagementDepartmentEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/position/add': {
      id: '/_home/user-role-management/position/add'
      path: '/user-role-management/position/add'
      fullPath: '/user-role-management/position/add'
      preLoaderRoute: typeof HomeUserRoleManagementPositionAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/position/edit': {
      id: '/_home/user-role-management/position/edit'
      path: '/user-role-management/position/edit'
      fullPath: '/user-role-management/position/edit'
      preLoaderRoute: typeof HomeUserRoleManagementPositionEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/books-zone/add': {
      id: '/_home/zone-settings/books-zone/add'
      path: '/zone-settings/books-zone/add'
      fullPath: '/zone-settings/books-zone/add'
      preLoaderRoute: typeof HomeZoneSettingsBooksZoneAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zone-connection-rates/add': {
      id: '/_home/zone-settings/zone-connection-rates/add'
      path: '/zone-settings/zone-connection-rates/add'
      fullPath: '/zone-settings/zone-connection-rates/add'
      preLoaderRoute: typeof HomeZoneSettingsZoneConnectionRatesAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zone-policy-due-date/add': {
      id: '/_home/zone-settings/zone-policy-due-date/add'
      path: '/zone-settings/zone-policy-due-date/add'
      fullPath: '/zone-settings/zone-policy-due-date/add'
      preLoaderRoute: typeof HomeZoneSettingsZonePolicyDueDateAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zone-policy-due-date/edit': {
      id: '/_home/zone-settings/zone-policy-due-date/edit'
      path: '/zone-settings/zone-policy-due-date/edit'
      fullPath: '/zone-settings/zone-policy-due-date/edit'
      preLoaderRoute: typeof HomeZoneSettingsZonePolicyDueDateEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zones/add': {
      id: '/_home/zone-settings/zones/add'
      path: '/zone-settings/zones/add'
      fullPath: '/zone-settings/zones/add'
      preLoaderRoute: typeof HomeZoneSettingsZonesAddImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zones/edit': {
      id: '/_home/zone-settings/zones/edit'
      path: '/zone-settings/zones/edit'
      fullPath: '/zone-settings/zones/edit'
      preLoaderRoute: typeof HomeZoneSettingsZonesEditImport
      parentRoute: typeof HomeImport
    }
    '/_home/message-templates/email/': {
      id: '/_home/message-templates/email/'
      path: '/message-templates/email'
      fullPath: '/message-templates/email'
      preLoaderRoute: typeof HomeMessageTemplatesEmailIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/message-templates/sms/': {
      id: '/_home/message-templates/sms/'
      path: '/message-templates/sms'
      fullPath: '/message-templates/sms'
      preLoaderRoute: typeof HomeMessageTemplatesSmsIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/commodity-rates/': {
      id: '/_home/meter-connection-settings/commodity-rates/'
      path: '/meter-connection-settings/commodity-rates'
      fullPath: '/meter-connection-settings/commodity-rates'
      preLoaderRoute: typeof HomeMeterConnectionSettingsCommodityRatesIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/connection-status/': {
      id: '/_home/meter-connection-settings/connection-status/'
      path: '/meter-connection-settings/connection-status'
      fullPath: '/meter-connection-settings/connection-status'
      preLoaderRoute: typeof HomeMeterConnectionSettingsConnectionStatusIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/connection-type/': {
      id: '/_home/meter-connection-settings/connection-type/'
      path: '/meter-connection-settings/connection-type'
      fullPath: '/meter-connection-settings/connection-type'
      preLoaderRoute: typeof HomeMeterConnectionSettingsConnectionTypeIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-reader/': {
      id: '/_home/meter-connection-settings/meter-reader/'
      path: '/meter-connection-settings/meter-reader'
      fullPath: '/meter-connection-settings/meter-reader'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterReaderIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-size-rates/': {
      id: '/_home/meter-connection-settings/meter-size-rates/'
      path: '/meter-connection-settings/meter-size-rates'
      fullPath: '/meter-connection-settings/meter-size-rates'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterSizeRatesIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-size/': {
      id: '/_home/meter-connection-settings/meter-size/'
      path: '/meter-connection-settings/meter-size'
      fullPath: '/meter-connection-settings/meter-size'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterSizeIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-status/': {
      id: '/_home/meter-connection-settings/meter-status/'
      path: '/meter-connection-settings/meter-status'
      fullPath: '/meter-connection-settings/meter-status'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterStatusIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/system-config/announcement/': {
      id: '/_home/system-config/announcement/'
      path: '/system-config/announcement'
      fullPath: '/system-config/announcement'
      preLoaderRoute: typeof HomeSystemConfigAnnouncementIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/billing-user-info/': {
      id: '/_home/user-role-management/billing-user-info/'
      path: '/user-role-management/billing-user-info'
      fullPath: '/user-role-management/billing-user-info'
      preLoaderRoute: typeof HomeUserRoleManagementBillingUserInfoIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/department/': {
      id: '/_home/user-role-management/department/'
      path: '/user-role-management/department'
      fullPath: '/user-role-management/department'
      preLoaderRoute: typeof HomeUserRoleManagementDepartmentIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/user-role-management/position/': {
      id: '/_home/user-role-management/position/'
      path: '/user-role-management/position'
      fullPath: '/user-role-management/position'
      preLoaderRoute: typeof HomeUserRoleManagementPositionIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/books-zone/': {
      id: '/_home/zone-settings/books-zone/'
      path: '/zone-settings/books-zone'
      fullPath: '/zone-settings/books-zone'
      preLoaderRoute: typeof HomeZoneSettingsBooksZoneIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zone-connection-rates/': {
      id: '/_home/zone-settings/zone-connection-rates/'
      path: '/zone-settings/zone-connection-rates'
      fullPath: '/zone-settings/zone-connection-rates'
      preLoaderRoute: typeof HomeZoneSettingsZoneConnectionRatesIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zone-policy-due-date/': {
      id: '/_home/zone-settings/zone-policy-due-date/'
      path: '/zone-settings/zone-policy-due-date'
      fullPath: '/zone-settings/zone-policy-due-date'
      preLoaderRoute: typeof HomeZoneSettingsZonePolicyDueDateIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zones/': {
      id: '/_home/zone-settings/zones/'
      path: '/zone-settings/zones'
      fullPath: '/zone-settings/zones'
      preLoaderRoute: typeof HomeZoneSettingsZonesIndexImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-reader/edit/$id': {
      id: '/_home/meter-connection-settings/meter-reader/edit/$id'
      path: '/meter-connection-settings/meter-reader/edit/$id'
      fullPath: '/meter-connection-settings/meter-reader/edit/$id'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterReaderEditIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/meter-connection-settings/meter-size/edit/$id': {
      id: '/_home/meter-connection-settings/meter-size/edit/$id'
      path: '/meter-connection-settings/meter-size/edit/$id'
      fullPath: '/meter-connection-settings/meter-size/edit/$id'
      preLoaderRoute: typeof HomeMeterConnectionSettingsMeterSizeEditIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/books-zone/edit/$id': {
      id: '/_home/zone-settings/books-zone/edit/$id'
      path: '/zone-settings/books-zone/edit/$id'
      fullPath: '/zone-settings/books-zone/edit/$id'
      preLoaderRoute: typeof HomeZoneSettingsBooksZoneEditIdImport
      parentRoute: typeof HomeImport
    }
    '/_home/zone-settings/zone-connection-rates/edit/$id': {
      id: '/_home/zone-settings/zone-connection-rates/edit/$id'
      path: '/zone-settings/zone-connection-rates/edit/$id'
      fullPath: '/zone-settings/zone-connection-rates/edit/$id'
      preLoaderRoute: typeof HomeZoneSettingsZoneConnectionRatesEditIdImport
      parentRoute: typeof HomeImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMfaAuthRoute: typeof AuthMfaAuthRoute
  AuthTrustDeviceRoute: typeof AuthTrustDeviceRoute
  AuthUnknownDeviceRoute: typeof AuthUnknownDeviceRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthMfaAuthRoute: AuthMfaAuthRoute,
  AuthTrustDeviceRoute: AuthTrustDeviceRoute,
  AuthUnknownDeviceRoute: AuthUnknownDeviceRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface HomeRouteChildren {
  HomeBillingRoute: typeof HomeBillingRoute
  HomeBillingAdjustmentRoute: typeof HomeBillingAdjustmentRoute
  HomeDashboardRoute: typeof HomeDashboardRoute
  HomeMapRoute: typeof HomeMapRoute
  HomeReportsRoute: typeof HomeReportsRoute
  HomeTrackingRoute: typeof HomeTrackingRoute
  HomeIndexRoute: typeof HomeIndexRoute
  HomeAnnouncementOverallAnnouncementRoute: typeof HomeAnnouncementOverallAnnouncementRoute
  HomeManageConsumersAddRoute: typeof HomeManageConsumersAddRoute
  HomeManageConsumersAddServiceRequestRoute: typeof HomeManageConsumersAddServiceRequestRoute
  HomeMeterInfoAddRoute: typeof HomeMeterInfoAddRoute
  HomeSettingsChangePasswordRoute: typeof HomeSettingsChangePasswordRoute
  HomeSettingsProfileRoute: typeof HomeSettingsProfileRoute
  HomeAnalyticsIndexRoute: typeof HomeAnalyticsIndexRoute
  HomeAnnouncementIndexRoute: typeof HomeAnnouncementIndexRoute
  HomeManageConsumersIndexRoute: typeof HomeManageConsumersIndexRoute
  HomeMeterInfoIndexRoute: typeof HomeMeterInfoIndexRoute
  HomeManageConsumersEditIdRoute: typeof HomeManageConsumersEditIdRoute
  HomeManageConsumersViewBillingHistoryIdRoute: typeof HomeManageConsumersViewBillingHistoryIdRoute
  HomeManageConsumersViewConsumptionHistoryIdRoute: typeof HomeManageConsumersViewConsumptionHistoryIdRoute
  HomeManageConsumersViewPaymentHistoryIdRoute: typeof HomeManageConsumersViewPaymentHistoryIdRoute
  HomeManageConsumersViewServiceRequestHistoryIdRoute: typeof HomeManageConsumersViewServiceRequestHistoryIdRoute
  HomeMessageTemplatesEmailAddRoute: typeof HomeMessageTemplatesEmailAddRoute
  HomeMessageTemplatesEmailEditRoute: typeof HomeMessageTemplatesEmailEditRoute
  HomeMessageTemplatesSmsAddRoute: typeof HomeMessageTemplatesSmsAddRoute
  HomeMessageTemplatesSmsEditRoute: typeof HomeMessageTemplatesSmsEditRoute
  HomeMeterConnectionSettingsConnectionStatusAddRoute: typeof HomeMeterConnectionSettingsConnectionStatusAddRoute
  HomeMeterConnectionSettingsConnectionStatusEditRoute: typeof HomeMeterConnectionSettingsConnectionStatusEditRoute
  HomeMeterConnectionSettingsConnectionTypeAddRoute: typeof HomeMeterConnectionSettingsConnectionTypeAddRoute
  HomeMeterConnectionSettingsConnectionTypeEditRoute: typeof HomeMeterConnectionSettingsConnectionTypeEditRoute
  HomeMeterConnectionSettingsMeterReaderAddRoute: typeof HomeMeterConnectionSettingsMeterReaderAddRoute
  HomeMeterConnectionSettingsMeterSizeRatesAddRoute: typeof HomeMeterConnectionSettingsMeterSizeRatesAddRoute
  HomeMeterConnectionSettingsMeterSizeAddRoute: typeof HomeMeterConnectionSettingsMeterSizeAddRoute
  HomeMeterConnectionSettingsMeterStatusAddRoute: typeof HomeMeterConnectionSettingsMeterStatusAddRoute
  HomeMeterConnectionSettingsMeterStatusEditRoute: typeof HomeMeterConnectionSettingsMeterStatusEditRoute
  HomeUserRoleManagementBillingUserInfoAddRoute: typeof HomeUserRoleManagementBillingUserInfoAddRoute
  HomeUserRoleManagementBillingUserInfoEditRoute: typeof HomeUserRoleManagementBillingUserInfoEditRoute
  HomeUserRoleManagementDepartmentAddRoute: typeof HomeUserRoleManagementDepartmentAddRoute
  HomeUserRoleManagementDepartmentEditRoute: typeof HomeUserRoleManagementDepartmentEditRoute
  HomeUserRoleManagementPositionAddRoute: typeof HomeUserRoleManagementPositionAddRoute
  HomeUserRoleManagementPositionEditRoute: typeof HomeUserRoleManagementPositionEditRoute
  HomeZoneSettingsBooksZoneAddRoute: typeof HomeZoneSettingsBooksZoneAddRoute
  HomeZoneSettingsZoneConnectionRatesAddRoute: typeof HomeZoneSettingsZoneConnectionRatesAddRoute
  HomeZoneSettingsZonePolicyDueDateAddRoute: typeof HomeZoneSettingsZonePolicyDueDateAddRoute
  HomeZoneSettingsZonePolicyDueDateEditRoute: typeof HomeZoneSettingsZonePolicyDueDateEditRoute
  HomeZoneSettingsZonesAddRoute: typeof HomeZoneSettingsZonesAddRoute
  HomeZoneSettingsZonesEditRoute: typeof HomeZoneSettingsZonesEditRoute
  HomeMessageTemplatesEmailIndexRoute: typeof HomeMessageTemplatesEmailIndexRoute
  HomeMessageTemplatesSmsIndexRoute: typeof HomeMessageTemplatesSmsIndexRoute
  HomeMeterConnectionSettingsCommodityRatesIndexRoute: typeof HomeMeterConnectionSettingsCommodityRatesIndexRoute
  HomeMeterConnectionSettingsConnectionStatusIndexRoute: typeof HomeMeterConnectionSettingsConnectionStatusIndexRoute
  HomeMeterConnectionSettingsConnectionTypeIndexRoute: typeof HomeMeterConnectionSettingsConnectionTypeIndexRoute
  HomeMeterConnectionSettingsMeterReaderIndexRoute: typeof HomeMeterConnectionSettingsMeterReaderIndexRoute
  HomeMeterConnectionSettingsMeterSizeRatesIndexRoute: typeof HomeMeterConnectionSettingsMeterSizeRatesIndexRoute
  HomeMeterConnectionSettingsMeterSizeIndexRoute: typeof HomeMeterConnectionSettingsMeterSizeIndexRoute
  HomeMeterConnectionSettingsMeterStatusIndexRoute: typeof HomeMeterConnectionSettingsMeterStatusIndexRoute
  HomeSystemConfigAnnouncementIndexRoute: typeof HomeSystemConfigAnnouncementIndexRoute
  HomeUserRoleManagementBillingUserInfoIndexRoute: typeof HomeUserRoleManagementBillingUserInfoIndexRoute
  HomeUserRoleManagementDepartmentIndexRoute: typeof HomeUserRoleManagementDepartmentIndexRoute
  HomeUserRoleManagementPositionIndexRoute: typeof HomeUserRoleManagementPositionIndexRoute
  HomeZoneSettingsBooksZoneIndexRoute: typeof HomeZoneSettingsBooksZoneIndexRoute
  HomeZoneSettingsZoneConnectionRatesIndexRoute: typeof HomeZoneSettingsZoneConnectionRatesIndexRoute
  HomeZoneSettingsZonePolicyDueDateIndexRoute: typeof HomeZoneSettingsZonePolicyDueDateIndexRoute
  HomeZoneSettingsZonesIndexRoute: typeof HomeZoneSettingsZonesIndexRoute
  HomeMeterConnectionSettingsMeterReaderEditIdRoute: typeof HomeMeterConnectionSettingsMeterReaderEditIdRoute
  HomeMeterConnectionSettingsMeterSizeEditIdRoute: typeof HomeMeterConnectionSettingsMeterSizeEditIdRoute
  HomeZoneSettingsBooksZoneEditIdRoute: typeof HomeZoneSettingsBooksZoneEditIdRoute
  HomeZoneSettingsZoneConnectionRatesEditIdRoute: typeof HomeZoneSettingsZoneConnectionRatesEditIdRoute
}

const HomeRouteChildren: HomeRouteChildren = {
  HomeBillingRoute: HomeBillingRoute,
  HomeBillingAdjustmentRoute: HomeBillingAdjustmentRoute,
  HomeDashboardRoute: HomeDashboardRoute,
  HomeMapRoute: HomeMapRoute,
  HomeReportsRoute: HomeReportsRoute,
  HomeTrackingRoute: HomeTrackingRoute,
  HomeIndexRoute: HomeIndexRoute,
  HomeAnnouncementOverallAnnouncementRoute:
    HomeAnnouncementOverallAnnouncementRoute,
  HomeManageConsumersAddRoute: HomeManageConsumersAddRoute,
  HomeManageConsumersAddServiceRequestRoute:
    HomeManageConsumersAddServiceRequestRoute,
  HomeMeterInfoAddRoute: HomeMeterInfoAddRoute,
  HomeSettingsChangePasswordRoute: HomeSettingsChangePasswordRoute,
  HomeSettingsProfileRoute: HomeSettingsProfileRoute,
  HomeAnalyticsIndexRoute: HomeAnalyticsIndexRoute,
  HomeAnnouncementIndexRoute: HomeAnnouncementIndexRoute,
  HomeManageConsumersIndexRoute: HomeManageConsumersIndexRoute,
  HomeMeterInfoIndexRoute: HomeMeterInfoIndexRoute,
  HomeManageConsumersEditIdRoute: HomeManageConsumersEditIdRoute,
  HomeManageConsumersViewBillingHistoryIdRoute:
    HomeManageConsumersViewBillingHistoryIdRoute,
  HomeManageConsumersViewConsumptionHistoryIdRoute:
    HomeManageConsumersViewConsumptionHistoryIdRoute,
  HomeManageConsumersViewPaymentHistoryIdRoute:
    HomeManageConsumersViewPaymentHistoryIdRoute,
  HomeManageConsumersViewServiceRequestHistoryIdRoute:
    HomeManageConsumersViewServiceRequestHistoryIdRoute,
  HomeMessageTemplatesEmailAddRoute: HomeMessageTemplatesEmailAddRoute,
  HomeMessageTemplatesEmailEditRoute: HomeMessageTemplatesEmailEditRoute,
  HomeMessageTemplatesSmsAddRoute: HomeMessageTemplatesSmsAddRoute,
  HomeMessageTemplatesSmsEditRoute: HomeMessageTemplatesSmsEditRoute,
  HomeMeterConnectionSettingsConnectionStatusAddRoute:
    HomeMeterConnectionSettingsConnectionStatusAddRoute,
  HomeMeterConnectionSettingsConnectionStatusEditRoute:
    HomeMeterConnectionSettingsConnectionStatusEditRoute,
  HomeMeterConnectionSettingsConnectionTypeAddRoute:
    HomeMeterConnectionSettingsConnectionTypeAddRoute,
  HomeMeterConnectionSettingsConnectionTypeEditRoute:
    HomeMeterConnectionSettingsConnectionTypeEditRoute,
  HomeMeterConnectionSettingsMeterReaderAddRoute:
    HomeMeterConnectionSettingsMeterReaderAddRoute,
  HomeMeterConnectionSettingsMeterSizeRatesAddRoute:
    HomeMeterConnectionSettingsMeterSizeRatesAddRoute,
  HomeMeterConnectionSettingsMeterSizeAddRoute:
    HomeMeterConnectionSettingsMeterSizeAddRoute,
  HomeMeterConnectionSettingsMeterStatusAddRoute:
    HomeMeterConnectionSettingsMeterStatusAddRoute,
  HomeMeterConnectionSettingsMeterStatusEditRoute:
    HomeMeterConnectionSettingsMeterStatusEditRoute,
  HomeUserRoleManagementBillingUserInfoAddRoute:
    HomeUserRoleManagementBillingUserInfoAddRoute,
  HomeUserRoleManagementBillingUserInfoEditRoute:
    HomeUserRoleManagementBillingUserInfoEditRoute,
  HomeUserRoleManagementDepartmentAddRoute:
    HomeUserRoleManagementDepartmentAddRoute,
  HomeUserRoleManagementDepartmentEditRoute:
    HomeUserRoleManagementDepartmentEditRoute,
  HomeUserRoleManagementPositionAddRoute:
    HomeUserRoleManagementPositionAddRoute,
  HomeUserRoleManagementPositionEditRoute:
    HomeUserRoleManagementPositionEditRoute,
  HomeZoneSettingsBooksZoneAddRoute: HomeZoneSettingsBooksZoneAddRoute,
  HomeZoneSettingsZoneConnectionRatesAddRoute:
    HomeZoneSettingsZoneConnectionRatesAddRoute,
  HomeZoneSettingsZonePolicyDueDateAddRoute:
    HomeZoneSettingsZonePolicyDueDateAddRoute,
  HomeZoneSettingsZonePolicyDueDateEditRoute:
    HomeZoneSettingsZonePolicyDueDateEditRoute,
  HomeZoneSettingsZonesAddRoute: HomeZoneSettingsZonesAddRoute,
  HomeZoneSettingsZonesEditRoute: HomeZoneSettingsZonesEditRoute,
  HomeMessageTemplatesEmailIndexRoute: HomeMessageTemplatesEmailIndexRoute,
  HomeMessageTemplatesSmsIndexRoute: HomeMessageTemplatesSmsIndexRoute,
  HomeMeterConnectionSettingsCommodityRatesIndexRoute:
    HomeMeterConnectionSettingsCommodityRatesIndexRoute,
  HomeMeterConnectionSettingsConnectionStatusIndexRoute:
    HomeMeterConnectionSettingsConnectionStatusIndexRoute,
  HomeMeterConnectionSettingsConnectionTypeIndexRoute:
    HomeMeterConnectionSettingsConnectionTypeIndexRoute,
  HomeMeterConnectionSettingsMeterReaderIndexRoute:
    HomeMeterConnectionSettingsMeterReaderIndexRoute,
  HomeMeterConnectionSettingsMeterSizeRatesIndexRoute:
    HomeMeterConnectionSettingsMeterSizeRatesIndexRoute,
  HomeMeterConnectionSettingsMeterSizeIndexRoute:
    HomeMeterConnectionSettingsMeterSizeIndexRoute,
  HomeMeterConnectionSettingsMeterStatusIndexRoute:
    HomeMeterConnectionSettingsMeterStatusIndexRoute,
  HomeSystemConfigAnnouncementIndexRoute:
    HomeSystemConfigAnnouncementIndexRoute,
  HomeUserRoleManagementBillingUserInfoIndexRoute:
    HomeUserRoleManagementBillingUserInfoIndexRoute,
  HomeUserRoleManagementDepartmentIndexRoute:
    HomeUserRoleManagementDepartmentIndexRoute,
  HomeUserRoleManagementPositionIndexRoute:
    HomeUserRoleManagementPositionIndexRoute,
  HomeZoneSettingsBooksZoneIndexRoute: HomeZoneSettingsBooksZoneIndexRoute,
  HomeZoneSettingsZoneConnectionRatesIndexRoute:
    HomeZoneSettingsZoneConnectionRatesIndexRoute,
  HomeZoneSettingsZonePolicyDueDateIndexRoute:
    HomeZoneSettingsZonePolicyDueDateIndexRoute,
  HomeZoneSettingsZonesIndexRoute: HomeZoneSettingsZonesIndexRoute,
  HomeMeterConnectionSettingsMeterReaderEditIdRoute:
    HomeMeterConnectionSettingsMeterReaderEditIdRoute,
  HomeMeterConnectionSettingsMeterSizeEditIdRoute:
    HomeMeterConnectionSettingsMeterSizeEditIdRoute,
  HomeZoneSettingsBooksZoneEditIdRoute: HomeZoneSettingsBooksZoneEditIdRoute,
  HomeZoneSettingsZoneConnectionRatesEditIdRoute:
    HomeZoneSettingsZoneConnectionRatesEditIdRoute,
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof HomeRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/contact-us': typeof ContactUsRoute
  '/not-found': typeof NotFoundRoute
  '/login': typeof AuthLoginRoute
  '/mfa-auth': typeof AuthMfaAuthRoute
  '/trust-device': typeof AuthTrustDeviceRoute
  '/unknown-device': typeof AuthUnknownDeviceRoute
  '/billing': typeof HomeBillingRoute
  '/billing-adjustment': typeof HomeBillingAdjustmentRoute
  '/dashboard': typeof HomeDashboardRoute
  '/map': typeof HomeMapRoute
  '/reports': typeof HomeReportsRoute
  '/tracking': typeof HomeTrackingRoute
  '/': typeof HomeIndexRoute
  '/announcement/overall-announcement': typeof HomeAnnouncementOverallAnnouncementRoute
  '/manage-consumers/add': typeof HomeManageConsumersAddRoute
  '/manage-consumers/add-service-request': typeof HomeManageConsumersAddServiceRequestRoute
  '/meter-info/add': typeof HomeMeterInfoAddRoute
  '/settings/change-password': typeof HomeSettingsChangePasswordRoute
  '/settings/profile': typeof HomeSettingsProfileRoute
  '/analytics': typeof HomeAnalyticsIndexRoute
  '/announcement': typeof HomeAnnouncementIndexRoute
  '/manage-consumers': typeof HomeManageConsumersIndexRoute
  '/meter-info': typeof HomeMeterInfoIndexRoute
  '/manage-consumers/edit/$id': typeof HomeManageConsumersEditIdRoute
  '/manage-consumers/view-billing-history/$id': typeof HomeManageConsumersViewBillingHistoryIdRoute
  '/manage-consumers/view-consumption-history/$id': typeof HomeManageConsumersViewConsumptionHistoryIdRoute
  '/manage-consumers/view-payment-history/$id': typeof HomeManageConsumersViewPaymentHistoryIdRoute
  '/manage-consumers/view-service-request-history/$id': typeof HomeManageConsumersViewServiceRequestHistoryIdRoute
  '/message-templates/email/add': typeof HomeMessageTemplatesEmailAddRoute
  '/message-templates/email/edit': typeof HomeMessageTemplatesEmailEditRoute
  '/message-templates/sms/add': typeof HomeMessageTemplatesSmsAddRoute
  '/message-templates/sms/edit': typeof HomeMessageTemplatesSmsEditRoute
  '/meter-connection-settings/connection-status/add': typeof HomeMeterConnectionSettingsConnectionStatusAddRoute
  '/meter-connection-settings/connection-status/edit': typeof HomeMeterConnectionSettingsConnectionStatusEditRoute
  '/meter-connection-settings/connection-type/add': typeof HomeMeterConnectionSettingsConnectionTypeAddRoute
  '/meter-connection-settings/connection-type/edit': typeof HomeMeterConnectionSettingsConnectionTypeEditRoute
  '/meter-connection-settings/meter-reader/add': typeof HomeMeterConnectionSettingsMeterReaderAddRoute
  '/meter-connection-settings/meter-size-rates/add': typeof HomeMeterConnectionSettingsMeterSizeRatesAddRoute
  '/meter-connection-settings/meter-size/add': typeof HomeMeterConnectionSettingsMeterSizeAddRoute
  '/meter-connection-settings/meter-status/add': typeof HomeMeterConnectionSettingsMeterStatusAddRoute
  '/meter-connection-settings/meter-status/edit': typeof HomeMeterConnectionSettingsMeterStatusEditRoute
  '/user-role-management/billing-user-info/add': typeof HomeUserRoleManagementBillingUserInfoAddRoute
  '/user-role-management/billing-user-info/edit': typeof HomeUserRoleManagementBillingUserInfoEditRoute
  '/user-role-management/department/add': typeof HomeUserRoleManagementDepartmentAddRoute
  '/user-role-management/department/edit': typeof HomeUserRoleManagementDepartmentEditRoute
  '/user-role-management/position/add': typeof HomeUserRoleManagementPositionAddRoute
  '/user-role-management/position/edit': typeof HomeUserRoleManagementPositionEditRoute
  '/zone-settings/books-zone/add': typeof HomeZoneSettingsBooksZoneAddRoute
  '/zone-settings/zone-connection-rates/add': typeof HomeZoneSettingsZoneConnectionRatesAddRoute
  '/zone-settings/zone-policy-due-date/add': typeof HomeZoneSettingsZonePolicyDueDateAddRoute
  '/zone-settings/zone-policy-due-date/edit': typeof HomeZoneSettingsZonePolicyDueDateEditRoute
  '/zone-settings/zones/add': typeof HomeZoneSettingsZonesAddRoute
  '/zone-settings/zones/edit': typeof HomeZoneSettingsZonesEditRoute
  '/message-templates/email': typeof HomeMessageTemplatesEmailIndexRoute
  '/message-templates/sms': typeof HomeMessageTemplatesSmsIndexRoute
  '/meter-connection-settings/commodity-rates': typeof HomeMeterConnectionSettingsCommodityRatesIndexRoute
  '/meter-connection-settings/connection-status': typeof HomeMeterConnectionSettingsConnectionStatusIndexRoute
  '/meter-connection-settings/connection-type': typeof HomeMeterConnectionSettingsConnectionTypeIndexRoute
  '/meter-connection-settings/meter-reader': typeof HomeMeterConnectionSettingsMeterReaderIndexRoute
  '/meter-connection-settings/meter-size-rates': typeof HomeMeterConnectionSettingsMeterSizeRatesIndexRoute
  '/meter-connection-settings/meter-size': typeof HomeMeterConnectionSettingsMeterSizeIndexRoute
  '/meter-connection-settings/meter-status': typeof HomeMeterConnectionSettingsMeterStatusIndexRoute
  '/system-config/announcement': typeof HomeSystemConfigAnnouncementIndexRoute
  '/user-role-management/billing-user-info': typeof HomeUserRoleManagementBillingUserInfoIndexRoute
  '/user-role-management/department': typeof HomeUserRoleManagementDepartmentIndexRoute
  '/user-role-management/position': typeof HomeUserRoleManagementPositionIndexRoute
  '/zone-settings/books-zone': typeof HomeZoneSettingsBooksZoneIndexRoute
  '/zone-settings/zone-connection-rates': typeof HomeZoneSettingsZoneConnectionRatesIndexRoute
  '/zone-settings/zone-policy-due-date': typeof HomeZoneSettingsZonePolicyDueDateIndexRoute
  '/zone-settings/zones': typeof HomeZoneSettingsZonesIndexRoute
  '/meter-connection-settings/meter-reader/edit/$id': typeof HomeMeterConnectionSettingsMeterReaderEditIdRoute
  '/meter-connection-settings/meter-size/edit/$id': typeof HomeMeterConnectionSettingsMeterSizeEditIdRoute
  '/zone-settings/books-zone/edit/$id': typeof HomeZoneSettingsBooksZoneEditIdRoute
  '/zone-settings/zone-connection-rates/edit/$id': typeof HomeZoneSettingsZoneConnectionRatesEditIdRoute
}

export interface FileRoutesByTo {
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/contact-us': typeof ContactUsRoute
  '/not-found': typeof NotFoundRoute
  '/login': typeof AuthLoginRoute
  '/mfa-auth': typeof AuthMfaAuthRoute
  '/trust-device': typeof AuthTrustDeviceRoute
  '/unknown-device': typeof AuthUnknownDeviceRoute
  '/billing': typeof HomeBillingRoute
  '/billing-adjustment': typeof HomeBillingAdjustmentRoute
  '/dashboard': typeof HomeDashboardRoute
  '/map': typeof HomeMapRoute
  '/reports': typeof HomeReportsRoute
  '/tracking': typeof HomeTrackingRoute
  '/': typeof HomeIndexRoute
  '/announcement/overall-announcement': typeof HomeAnnouncementOverallAnnouncementRoute
  '/manage-consumers/add': typeof HomeManageConsumersAddRoute
  '/manage-consumers/add-service-request': typeof HomeManageConsumersAddServiceRequestRoute
  '/meter-info/add': typeof HomeMeterInfoAddRoute
  '/settings/change-password': typeof HomeSettingsChangePasswordRoute
  '/settings/profile': typeof HomeSettingsProfileRoute
  '/analytics': typeof HomeAnalyticsIndexRoute
  '/announcement': typeof HomeAnnouncementIndexRoute
  '/manage-consumers': typeof HomeManageConsumersIndexRoute
  '/meter-info': typeof HomeMeterInfoIndexRoute
  '/manage-consumers/edit/$id': typeof HomeManageConsumersEditIdRoute
  '/manage-consumers/view-billing-history/$id': typeof HomeManageConsumersViewBillingHistoryIdRoute
  '/manage-consumers/view-consumption-history/$id': typeof HomeManageConsumersViewConsumptionHistoryIdRoute
  '/manage-consumers/view-payment-history/$id': typeof HomeManageConsumersViewPaymentHistoryIdRoute
  '/manage-consumers/view-service-request-history/$id': typeof HomeManageConsumersViewServiceRequestHistoryIdRoute
  '/message-templates/email/add': typeof HomeMessageTemplatesEmailAddRoute
  '/message-templates/email/edit': typeof HomeMessageTemplatesEmailEditRoute
  '/message-templates/sms/add': typeof HomeMessageTemplatesSmsAddRoute
  '/message-templates/sms/edit': typeof HomeMessageTemplatesSmsEditRoute
  '/meter-connection-settings/connection-status/add': typeof HomeMeterConnectionSettingsConnectionStatusAddRoute
  '/meter-connection-settings/connection-status/edit': typeof HomeMeterConnectionSettingsConnectionStatusEditRoute
  '/meter-connection-settings/connection-type/add': typeof HomeMeterConnectionSettingsConnectionTypeAddRoute
  '/meter-connection-settings/connection-type/edit': typeof HomeMeterConnectionSettingsConnectionTypeEditRoute
  '/meter-connection-settings/meter-reader/add': typeof HomeMeterConnectionSettingsMeterReaderAddRoute
  '/meter-connection-settings/meter-size-rates/add': typeof HomeMeterConnectionSettingsMeterSizeRatesAddRoute
  '/meter-connection-settings/meter-size/add': typeof HomeMeterConnectionSettingsMeterSizeAddRoute
  '/meter-connection-settings/meter-status/add': typeof HomeMeterConnectionSettingsMeterStatusAddRoute
  '/meter-connection-settings/meter-status/edit': typeof HomeMeterConnectionSettingsMeterStatusEditRoute
  '/user-role-management/billing-user-info/add': typeof HomeUserRoleManagementBillingUserInfoAddRoute
  '/user-role-management/billing-user-info/edit': typeof HomeUserRoleManagementBillingUserInfoEditRoute
  '/user-role-management/department/add': typeof HomeUserRoleManagementDepartmentAddRoute
  '/user-role-management/department/edit': typeof HomeUserRoleManagementDepartmentEditRoute
  '/user-role-management/position/add': typeof HomeUserRoleManagementPositionAddRoute
  '/user-role-management/position/edit': typeof HomeUserRoleManagementPositionEditRoute
  '/zone-settings/books-zone/add': typeof HomeZoneSettingsBooksZoneAddRoute
  '/zone-settings/zone-connection-rates/add': typeof HomeZoneSettingsZoneConnectionRatesAddRoute
  '/zone-settings/zone-policy-due-date/add': typeof HomeZoneSettingsZonePolicyDueDateAddRoute
  '/zone-settings/zone-policy-due-date/edit': typeof HomeZoneSettingsZonePolicyDueDateEditRoute
  '/zone-settings/zones/add': typeof HomeZoneSettingsZonesAddRoute
  '/zone-settings/zones/edit': typeof HomeZoneSettingsZonesEditRoute
  '/message-templates/email': typeof HomeMessageTemplatesEmailIndexRoute
  '/message-templates/sms': typeof HomeMessageTemplatesSmsIndexRoute
  '/meter-connection-settings/commodity-rates': typeof HomeMeterConnectionSettingsCommodityRatesIndexRoute
  '/meter-connection-settings/connection-status': typeof HomeMeterConnectionSettingsConnectionStatusIndexRoute
  '/meter-connection-settings/connection-type': typeof HomeMeterConnectionSettingsConnectionTypeIndexRoute
  '/meter-connection-settings/meter-reader': typeof HomeMeterConnectionSettingsMeterReaderIndexRoute
  '/meter-connection-settings/meter-size-rates': typeof HomeMeterConnectionSettingsMeterSizeRatesIndexRoute
  '/meter-connection-settings/meter-size': typeof HomeMeterConnectionSettingsMeterSizeIndexRoute
  '/meter-connection-settings/meter-status': typeof HomeMeterConnectionSettingsMeterStatusIndexRoute
  '/system-config/announcement': typeof HomeSystemConfigAnnouncementIndexRoute
  '/user-role-management/billing-user-info': typeof HomeUserRoleManagementBillingUserInfoIndexRoute
  '/user-role-management/department': typeof HomeUserRoleManagementDepartmentIndexRoute
  '/user-role-management/position': typeof HomeUserRoleManagementPositionIndexRoute
  '/zone-settings/books-zone': typeof HomeZoneSettingsBooksZoneIndexRoute
  '/zone-settings/zone-connection-rates': typeof HomeZoneSettingsZoneConnectionRatesIndexRoute
  '/zone-settings/zone-policy-due-date': typeof HomeZoneSettingsZonePolicyDueDateIndexRoute
  '/zone-settings/zones': typeof HomeZoneSettingsZonesIndexRoute
  '/meter-connection-settings/meter-reader/edit/$id': typeof HomeMeterConnectionSettingsMeterReaderEditIdRoute
  '/meter-connection-settings/meter-size/edit/$id': typeof HomeMeterConnectionSettingsMeterSizeEditIdRoute
  '/zone-settings/books-zone/edit/$id': typeof HomeZoneSettingsBooksZoneEditIdRoute
  '/zone-settings/zone-connection-rates/edit/$id': typeof HomeZoneSettingsZoneConnectionRatesEditIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_home': typeof HomeRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/contact-us': typeof ContactUsRoute
  '/not-found': typeof NotFoundRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/mfa-auth': typeof AuthMfaAuthRoute
  '/_auth/trust-device': typeof AuthTrustDeviceRoute
  '/_auth/unknown-device': typeof AuthUnknownDeviceRoute
  '/_home/billing': typeof HomeBillingRoute
  '/_home/billing-adjustment': typeof HomeBillingAdjustmentRoute
  '/_home/dashboard': typeof HomeDashboardRoute
  '/_home/map': typeof HomeMapRoute
  '/_home/reports': typeof HomeReportsRoute
  '/_home/tracking': typeof HomeTrackingRoute
  '/_home/': typeof HomeIndexRoute
  '/_home/announcement/overall-announcement': typeof HomeAnnouncementOverallAnnouncementRoute
  '/_home/manage-consumers/add': typeof HomeManageConsumersAddRoute
  '/_home/manage-consumers/add-service-request': typeof HomeManageConsumersAddServiceRequestRoute
  '/_home/meter-info/add': typeof HomeMeterInfoAddRoute
  '/_home/settings/change-password': typeof HomeSettingsChangePasswordRoute
  '/_home/settings/profile': typeof HomeSettingsProfileRoute
  '/_home/analytics/': typeof HomeAnalyticsIndexRoute
  '/_home/announcement/': typeof HomeAnnouncementIndexRoute
  '/_home/manage-consumers/': typeof HomeManageConsumersIndexRoute
  '/_home/meter-info/': typeof HomeMeterInfoIndexRoute
  '/_home/manage-consumers/edit/$id': typeof HomeManageConsumersEditIdRoute
  '/_home/manage-consumers/view-billing-history/$id': typeof HomeManageConsumersViewBillingHistoryIdRoute
  '/_home/manage-consumers/view-consumption-history/$id': typeof HomeManageConsumersViewConsumptionHistoryIdRoute
  '/_home/manage-consumers/view-payment-history/$id': typeof HomeManageConsumersViewPaymentHistoryIdRoute
  '/_home/manage-consumers/view-service-request-history/$id': typeof HomeManageConsumersViewServiceRequestHistoryIdRoute
  '/_home/message-templates/email/add': typeof HomeMessageTemplatesEmailAddRoute
  '/_home/message-templates/email/edit': typeof HomeMessageTemplatesEmailEditRoute
  '/_home/message-templates/sms/add': typeof HomeMessageTemplatesSmsAddRoute
  '/_home/message-templates/sms/edit': typeof HomeMessageTemplatesSmsEditRoute
  '/_home/meter-connection-settings/connection-status/add': typeof HomeMeterConnectionSettingsConnectionStatusAddRoute
  '/_home/meter-connection-settings/connection-status/edit': typeof HomeMeterConnectionSettingsConnectionStatusEditRoute
  '/_home/meter-connection-settings/connection-type/add': typeof HomeMeterConnectionSettingsConnectionTypeAddRoute
  '/_home/meter-connection-settings/connection-type/edit': typeof HomeMeterConnectionSettingsConnectionTypeEditRoute
  '/_home/meter-connection-settings/meter-reader/add': typeof HomeMeterConnectionSettingsMeterReaderAddRoute
  '/_home/meter-connection-settings/meter-size-rates/add': typeof HomeMeterConnectionSettingsMeterSizeRatesAddRoute
  '/_home/meter-connection-settings/meter-size/add': typeof HomeMeterConnectionSettingsMeterSizeAddRoute
  '/_home/meter-connection-settings/meter-status/add': typeof HomeMeterConnectionSettingsMeterStatusAddRoute
  '/_home/meter-connection-settings/meter-status/edit': typeof HomeMeterConnectionSettingsMeterStatusEditRoute
  '/_home/user-role-management/billing-user-info/add': typeof HomeUserRoleManagementBillingUserInfoAddRoute
  '/_home/user-role-management/billing-user-info/edit': typeof HomeUserRoleManagementBillingUserInfoEditRoute
  '/_home/user-role-management/department/add': typeof HomeUserRoleManagementDepartmentAddRoute
  '/_home/user-role-management/department/edit': typeof HomeUserRoleManagementDepartmentEditRoute
  '/_home/user-role-management/position/add': typeof HomeUserRoleManagementPositionAddRoute
  '/_home/user-role-management/position/edit': typeof HomeUserRoleManagementPositionEditRoute
  '/_home/zone-settings/books-zone/add': typeof HomeZoneSettingsBooksZoneAddRoute
  '/_home/zone-settings/zone-connection-rates/add': typeof HomeZoneSettingsZoneConnectionRatesAddRoute
  '/_home/zone-settings/zone-policy-due-date/add': typeof HomeZoneSettingsZonePolicyDueDateAddRoute
  '/_home/zone-settings/zone-policy-due-date/edit': typeof HomeZoneSettingsZonePolicyDueDateEditRoute
  '/_home/zone-settings/zones/add': typeof HomeZoneSettingsZonesAddRoute
  '/_home/zone-settings/zones/edit': typeof HomeZoneSettingsZonesEditRoute
  '/_home/message-templates/email/': typeof HomeMessageTemplatesEmailIndexRoute
  '/_home/message-templates/sms/': typeof HomeMessageTemplatesSmsIndexRoute
  '/_home/meter-connection-settings/commodity-rates/': typeof HomeMeterConnectionSettingsCommodityRatesIndexRoute
  '/_home/meter-connection-settings/connection-status/': typeof HomeMeterConnectionSettingsConnectionStatusIndexRoute
  '/_home/meter-connection-settings/connection-type/': typeof HomeMeterConnectionSettingsConnectionTypeIndexRoute
  '/_home/meter-connection-settings/meter-reader/': typeof HomeMeterConnectionSettingsMeterReaderIndexRoute
  '/_home/meter-connection-settings/meter-size-rates/': typeof HomeMeterConnectionSettingsMeterSizeRatesIndexRoute
  '/_home/meter-connection-settings/meter-size/': typeof HomeMeterConnectionSettingsMeterSizeIndexRoute
  '/_home/meter-connection-settings/meter-status/': typeof HomeMeterConnectionSettingsMeterStatusIndexRoute
  '/_home/system-config/announcement/': typeof HomeSystemConfigAnnouncementIndexRoute
  '/_home/user-role-management/billing-user-info/': typeof HomeUserRoleManagementBillingUserInfoIndexRoute
  '/_home/user-role-management/department/': typeof HomeUserRoleManagementDepartmentIndexRoute
  '/_home/user-role-management/position/': typeof HomeUserRoleManagementPositionIndexRoute
  '/_home/zone-settings/books-zone/': typeof HomeZoneSettingsBooksZoneIndexRoute
  '/_home/zone-settings/zone-connection-rates/': typeof HomeZoneSettingsZoneConnectionRatesIndexRoute
  '/_home/zone-settings/zone-policy-due-date/': typeof HomeZoneSettingsZonePolicyDueDateIndexRoute
  '/_home/zone-settings/zones/': typeof HomeZoneSettingsZonesIndexRoute
  '/_home/meter-connection-settings/meter-reader/edit/$id': typeof HomeMeterConnectionSettingsMeterReaderEditIdRoute
  '/_home/meter-connection-settings/meter-size/edit/$id': typeof HomeMeterConnectionSettingsMeterSizeEditIdRoute
  '/_home/zone-settings/books-zone/edit/$id': typeof HomeZoneSettingsBooksZoneEditIdRoute
  '/_home/zone-settings/zone-connection-rates/edit/$id': typeof HomeZoneSettingsZoneConnectionRatesEditIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/access-denied'
    | '/contact-us'
    | '/not-found'
    | '/login'
    | '/mfa-auth'
    | '/trust-device'
    | '/unknown-device'
    | '/billing'
    | '/billing-adjustment'
    | '/dashboard'
    | '/map'
    | '/reports'
    | '/tracking'
    | '/'
    | '/announcement/overall-announcement'
    | '/manage-consumers/add'
    | '/manage-consumers/add-service-request'
    | '/meter-info/add'
    | '/settings/change-password'
    | '/settings/profile'
    | '/analytics'
    | '/announcement'
    | '/manage-consumers'
    | '/meter-info'
    | '/manage-consumers/edit/$id'
    | '/manage-consumers/view-billing-history/$id'
    | '/manage-consumers/view-consumption-history/$id'
    | '/manage-consumers/view-payment-history/$id'
    | '/manage-consumers/view-service-request-history/$id'
    | '/message-templates/email/add'
    | '/message-templates/email/edit'
    | '/message-templates/sms/add'
    | '/message-templates/sms/edit'
    | '/meter-connection-settings/connection-status/add'
    | '/meter-connection-settings/connection-status/edit'
    | '/meter-connection-settings/connection-type/add'
    | '/meter-connection-settings/connection-type/edit'
    | '/meter-connection-settings/meter-reader/add'
    | '/meter-connection-settings/meter-size-rates/add'
    | '/meter-connection-settings/meter-size/add'
    | '/meter-connection-settings/meter-status/add'
    | '/meter-connection-settings/meter-status/edit'
    | '/user-role-management/billing-user-info/add'
    | '/user-role-management/billing-user-info/edit'
    | '/user-role-management/department/add'
    | '/user-role-management/department/edit'
    | '/user-role-management/position/add'
    | '/user-role-management/position/edit'
    | '/zone-settings/books-zone/add'
    | '/zone-settings/zone-connection-rates/add'
    | '/zone-settings/zone-policy-due-date/add'
    | '/zone-settings/zone-policy-due-date/edit'
    | '/zone-settings/zones/add'
    | '/zone-settings/zones/edit'
    | '/message-templates/email'
    | '/message-templates/sms'
    | '/meter-connection-settings/commodity-rates'
    | '/meter-connection-settings/connection-status'
    | '/meter-connection-settings/connection-type'
    | '/meter-connection-settings/meter-reader'
    | '/meter-connection-settings/meter-size-rates'
    | '/meter-connection-settings/meter-size'
    | '/meter-connection-settings/meter-status'
    | '/system-config/announcement'
    | '/user-role-management/billing-user-info'
    | '/user-role-management/department'
    | '/user-role-management/position'
    | '/zone-settings/books-zone'
    | '/zone-settings/zone-connection-rates'
    | '/zone-settings/zone-policy-due-date'
    | '/zone-settings/zones'
    | '/meter-connection-settings/meter-reader/edit/$id'
    | '/meter-connection-settings/meter-size/edit/$id'
    | '/zone-settings/books-zone/edit/$id'
    | '/zone-settings/zone-connection-rates/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/access-denied'
    | '/contact-us'
    | '/not-found'
    | '/login'
    | '/mfa-auth'
    | '/trust-device'
    | '/unknown-device'
    | '/billing'
    | '/billing-adjustment'
    | '/dashboard'
    | '/map'
    | '/reports'
    | '/tracking'
    | '/'
    | '/announcement/overall-announcement'
    | '/manage-consumers/add'
    | '/manage-consumers/add-service-request'
    | '/meter-info/add'
    | '/settings/change-password'
    | '/settings/profile'
    | '/analytics'
    | '/announcement'
    | '/manage-consumers'
    | '/meter-info'
    | '/manage-consumers/edit/$id'
    | '/manage-consumers/view-billing-history/$id'
    | '/manage-consumers/view-consumption-history/$id'
    | '/manage-consumers/view-payment-history/$id'
    | '/manage-consumers/view-service-request-history/$id'
    | '/message-templates/email/add'
    | '/message-templates/email/edit'
    | '/message-templates/sms/add'
    | '/message-templates/sms/edit'
    | '/meter-connection-settings/connection-status/add'
    | '/meter-connection-settings/connection-status/edit'
    | '/meter-connection-settings/connection-type/add'
    | '/meter-connection-settings/connection-type/edit'
    | '/meter-connection-settings/meter-reader/add'
    | '/meter-connection-settings/meter-size-rates/add'
    | '/meter-connection-settings/meter-size/add'
    | '/meter-connection-settings/meter-status/add'
    | '/meter-connection-settings/meter-status/edit'
    | '/user-role-management/billing-user-info/add'
    | '/user-role-management/billing-user-info/edit'
    | '/user-role-management/department/add'
    | '/user-role-management/department/edit'
    | '/user-role-management/position/add'
    | '/user-role-management/position/edit'
    | '/zone-settings/books-zone/add'
    | '/zone-settings/zone-connection-rates/add'
    | '/zone-settings/zone-policy-due-date/add'
    | '/zone-settings/zone-policy-due-date/edit'
    | '/zone-settings/zones/add'
    | '/zone-settings/zones/edit'
    | '/message-templates/email'
    | '/message-templates/sms'
    | '/meter-connection-settings/commodity-rates'
    | '/meter-connection-settings/connection-status'
    | '/meter-connection-settings/connection-type'
    | '/meter-connection-settings/meter-reader'
    | '/meter-connection-settings/meter-size-rates'
    | '/meter-connection-settings/meter-size'
    | '/meter-connection-settings/meter-status'
    | '/system-config/announcement'
    | '/user-role-management/billing-user-info'
    | '/user-role-management/department'
    | '/user-role-management/position'
    | '/zone-settings/books-zone'
    | '/zone-settings/zone-connection-rates'
    | '/zone-settings/zone-policy-due-date'
    | '/zone-settings/zones'
    | '/meter-connection-settings/meter-reader/edit/$id'
    | '/meter-connection-settings/meter-size/edit/$id'
    | '/zone-settings/books-zone/edit/$id'
    | '/zone-settings/zone-connection-rates/edit/$id'
  id:
    | '__root__'
    | '/_auth'
    | '/_home'
    | '/access-denied'
    | '/contact-us'
    | '/not-found'
    | '/_auth/login'
    | '/_auth/mfa-auth'
    | '/_auth/trust-device'
    | '/_auth/unknown-device'
    | '/_home/billing'
    | '/_home/billing-adjustment'
    | '/_home/dashboard'
    | '/_home/map'
    | '/_home/reports'
    | '/_home/tracking'
    | '/_home/'
    | '/_home/announcement/overall-announcement'
    | '/_home/manage-consumers/add'
    | '/_home/manage-consumers/add-service-request'
    | '/_home/meter-info/add'
    | '/_home/settings/change-password'
    | '/_home/settings/profile'
    | '/_home/analytics/'
    | '/_home/announcement/'
    | '/_home/manage-consumers/'
    | '/_home/meter-info/'
    | '/_home/manage-consumers/edit/$id'
    | '/_home/manage-consumers/view-billing-history/$id'
    | '/_home/manage-consumers/view-consumption-history/$id'
    | '/_home/manage-consumers/view-payment-history/$id'
    | '/_home/manage-consumers/view-service-request-history/$id'
    | '/_home/message-templates/email/add'
    | '/_home/message-templates/email/edit'
    | '/_home/message-templates/sms/add'
    | '/_home/message-templates/sms/edit'
    | '/_home/meter-connection-settings/connection-status/add'
    | '/_home/meter-connection-settings/connection-status/edit'
    | '/_home/meter-connection-settings/connection-type/add'
    | '/_home/meter-connection-settings/connection-type/edit'
    | '/_home/meter-connection-settings/meter-reader/add'
    | '/_home/meter-connection-settings/meter-size-rates/add'
    | '/_home/meter-connection-settings/meter-size/add'
    | '/_home/meter-connection-settings/meter-status/add'
    | '/_home/meter-connection-settings/meter-status/edit'
    | '/_home/user-role-management/billing-user-info/add'
    | '/_home/user-role-management/billing-user-info/edit'
    | '/_home/user-role-management/department/add'
    | '/_home/user-role-management/department/edit'
    | '/_home/user-role-management/position/add'
    | '/_home/user-role-management/position/edit'
    | '/_home/zone-settings/books-zone/add'
    | '/_home/zone-settings/zone-connection-rates/add'
    | '/_home/zone-settings/zone-policy-due-date/add'
    | '/_home/zone-settings/zone-policy-due-date/edit'
    | '/_home/zone-settings/zones/add'
    | '/_home/zone-settings/zones/edit'
    | '/_home/message-templates/email/'
    | '/_home/message-templates/sms/'
    | '/_home/meter-connection-settings/commodity-rates/'
    | '/_home/meter-connection-settings/connection-status/'
    | '/_home/meter-connection-settings/connection-type/'
    | '/_home/meter-connection-settings/meter-reader/'
    | '/_home/meter-connection-settings/meter-size-rates/'
    | '/_home/meter-connection-settings/meter-size/'
    | '/_home/meter-connection-settings/meter-status/'
    | '/_home/system-config/announcement/'
    | '/_home/user-role-management/billing-user-info/'
    | '/_home/user-role-management/department/'
    | '/_home/user-role-management/position/'
    | '/_home/zone-settings/books-zone/'
    | '/_home/zone-settings/zone-connection-rates/'
    | '/_home/zone-settings/zone-policy-due-date/'
    | '/_home/zone-settings/zones/'
    | '/_home/meter-connection-settings/meter-reader/edit/$id'
    | '/_home/meter-connection-settings/meter-size/edit/$id'
    | '/_home/zone-settings/books-zone/edit/$id'
    | '/_home/zone-settings/zone-connection-rates/edit/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  HomeRoute: typeof HomeRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  ContactUsRoute: typeof ContactUsRoute
  NotFoundRoute: typeof NotFoundRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  HomeRoute: HomeRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  ContactUsRoute: ContactUsRoute,
  NotFoundRoute: NotFoundRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_home",
        "/access-denied",
        "/contact-us",
        "/not-found"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/mfa-auth",
        "/_auth/trust-device",
        "/_auth/unknown-device"
      ]
    },
    "/_home": {
      "filePath": "_home.tsx",
      "children": [
        "/_home/billing",
        "/_home/billing-adjustment",
        "/_home/dashboard",
        "/_home/map",
        "/_home/reports",
        "/_home/tracking",
        "/_home/",
        "/_home/announcement/overall-announcement",
        "/_home/manage-consumers/add",
        "/_home/manage-consumers/add-service-request",
        "/_home/meter-info/add",
        "/_home/settings/change-password",
        "/_home/settings/profile",
        "/_home/analytics/",
        "/_home/announcement/",
        "/_home/manage-consumers/",
        "/_home/meter-info/",
        "/_home/manage-consumers/edit/$id",
        "/_home/manage-consumers/view-billing-history/$id",
        "/_home/manage-consumers/view-consumption-history/$id",
        "/_home/manage-consumers/view-payment-history/$id",
        "/_home/manage-consumers/view-service-request-history/$id",
        "/_home/message-templates/email/add",
        "/_home/message-templates/email/edit",
        "/_home/message-templates/sms/add",
        "/_home/message-templates/sms/edit",
        "/_home/meter-connection-settings/connection-status/add",
        "/_home/meter-connection-settings/connection-status/edit",
        "/_home/meter-connection-settings/connection-type/add",
        "/_home/meter-connection-settings/connection-type/edit",
        "/_home/meter-connection-settings/meter-reader/add",
        "/_home/meter-connection-settings/meter-size-rates/add",
        "/_home/meter-connection-settings/meter-size/add",
        "/_home/meter-connection-settings/meter-status/add",
        "/_home/meter-connection-settings/meter-status/edit",
        "/_home/user-role-management/billing-user-info/add",
        "/_home/user-role-management/billing-user-info/edit",
        "/_home/user-role-management/department/add",
        "/_home/user-role-management/department/edit",
        "/_home/user-role-management/position/add",
        "/_home/user-role-management/position/edit",
        "/_home/zone-settings/books-zone/add",
        "/_home/zone-settings/zone-connection-rates/add",
        "/_home/zone-settings/zone-policy-due-date/add",
        "/_home/zone-settings/zone-policy-due-date/edit",
        "/_home/zone-settings/zones/add",
        "/_home/zone-settings/zones/edit",
        "/_home/message-templates/email/",
        "/_home/message-templates/sms/",
        "/_home/meter-connection-settings/commodity-rates/",
        "/_home/meter-connection-settings/connection-status/",
        "/_home/meter-connection-settings/connection-type/",
        "/_home/meter-connection-settings/meter-reader/",
        "/_home/meter-connection-settings/meter-size-rates/",
        "/_home/meter-connection-settings/meter-size/",
        "/_home/meter-connection-settings/meter-status/",
        "/_home/system-config/announcement/",
        "/_home/user-role-management/billing-user-info/",
        "/_home/user-role-management/department/",
        "/_home/user-role-management/position/",
        "/_home/zone-settings/books-zone/",
        "/_home/zone-settings/zone-connection-rates/",
        "/_home/zone-settings/zone-policy-due-date/",
        "/_home/zone-settings/zones/",
        "/_home/meter-connection-settings/meter-reader/edit/$id",
        "/_home/meter-connection-settings/meter-size/edit/$id",
        "/_home/zone-settings/books-zone/edit/$id",
        "/_home/zone-settings/zone-connection-rates/edit/$id"
      ]
    },
    "/access-denied": {
      "filePath": "access-denied.tsx"
    },
    "/contact-us": {
      "filePath": "contact-us.tsx"
    },
    "/not-found": {
      "filePath": "not-found.tsx"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_auth/mfa-auth": {
      "filePath": "_auth/mfa-auth.tsx",
      "parent": "/_auth"
    },
    "/_auth/trust-device": {
      "filePath": "_auth/trust-device.tsx",
      "parent": "/_auth"
    },
    "/_auth/unknown-device": {
      "filePath": "_auth/unknown-device.tsx",
      "parent": "/_auth"
    },
    "/_home/billing": {
      "filePath": "_home/billing.tsx",
      "parent": "/_home"
    },
    "/_home/billing-adjustment": {
      "filePath": "_home/billing-adjustment.tsx",
      "parent": "/_home"
    },
    "/_home/dashboard": {
      "filePath": "_home/dashboard.tsx",
      "parent": "/_home"
    },
    "/_home/map": {
      "filePath": "_home/map.tsx",
      "parent": "/_home"
    },
    "/_home/reports": {
      "filePath": "_home/reports.tsx",
      "parent": "/_home"
    },
    "/_home/tracking": {
      "filePath": "_home/tracking.tsx",
      "parent": "/_home"
    },
    "/_home/": {
      "filePath": "_home/index.tsx",
      "parent": "/_home"
    },
    "/_home/announcement/overall-announcement": {
      "filePath": "_home/announcement/overall-announcement.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/add": {
      "filePath": "_home/manage-consumers/add.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/add-service-request": {
      "filePath": "_home/manage-consumers/add-service-request.tsx",
      "parent": "/_home"
    },
    "/_home/meter-info/add": {
      "filePath": "_home/meter-info/add.tsx",
      "parent": "/_home"
    },
    "/_home/settings/change-password": {
      "filePath": "_home/settings/change-password.tsx",
      "parent": "/_home"
    },
    "/_home/settings/profile": {
      "filePath": "_home/settings/profile.tsx",
      "parent": "/_home"
    },
    "/_home/analytics/": {
      "filePath": "_home/analytics/index.tsx",
      "parent": "/_home"
    },
    "/_home/announcement/": {
      "filePath": "_home/announcement/index.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/": {
      "filePath": "_home/manage-consumers/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-info/": {
      "filePath": "_home/meter-info/index.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/edit/$id": {
      "filePath": "_home/manage-consumers/edit.$id.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/view-billing-history/$id": {
      "filePath": "_home/manage-consumers/view-billing-history.$id.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/view-consumption-history/$id": {
      "filePath": "_home/manage-consumers/view-consumption-history.$id.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/view-payment-history/$id": {
      "filePath": "_home/manage-consumers/view-payment-history.$id.tsx",
      "parent": "/_home"
    },
    "/_home/manage-consumers/view-service-request-history/$id": {
      "filePath": "_home/manage-consumers/view-service-request-history.$id.tsx",
      "parent": "/_home"
    },
    "/_home/message-templates/email/add": {
      "filePath": "_home/message-templates/email/add.tsx",
      "parent": "/_home"
    },
    "/_home/message-templates/email/edit": {
      "filePath": "_home/message-templates/email/edit.tsx",
      "parent": "/_home"
    },
    "/_home/message-templates/sms/add": {
      "filePath": "_home/message-templates/sms/add.tsx",
      "parent": "/_home"
    },
    "/_home/message-templates/sms/edit": {
      "filePath": "_home/message-templates/sms/edit.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/connection-status/add": {
      "filePath": "_home/meter-connection-settings/connection-status/add.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/connection-status/edit": {
      "filePath": "_home/meter-connection-settings/connection-status/edit.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/connection-type/add": {
      "filePath": "_home/meter-connection-settings/connection-type/add.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/connection-type/edit": {
      "filePath": "_home/meter-connection-settings/connection-type/edit.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-reader/add": {
      "filePath": "_home/meter-connection-settings/meter-reader/add.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-size-rates/add": {
      "filePath": "_home/meter-connection-settings/meter-size-rates/add.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-size/add": {
      "filePath": "_home/meter-connection-settings/meter-size/add.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-status/add": {
      "filePath": "_home/meter-connection-settings/meter-status/add.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-status/edit": {
      "filePath": "_home/meter-connection-settings/meter-status/edit.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/billing-user-info/add": {
      "filePath": "_home/user-role-management/billing-user-info/add.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/billing-user-info/edit": {
      "filePath": "_home/user-role-management/billing-user-info/edit.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/department/add": {
      "filePath": "_home/user-role-management/department/add.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/department/edit": {
      "filePath": "_home/user-role-management/department/edit.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/position/add": {
      "filePath": "_home/user-role-management/position/add.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/position/edit": {
      "filePath": "_home/user-role-management/position/edit.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/books-zone/add": {
      "filePath": "_home/zone-settings/books-zone/add.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zone-connection-rates/add": {
      "filePath": "_home/zone-settings/zone-connection-rates/add.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zone-policy-due-date/add": {
      "filePath": "_home/zone-settings/zone-policy-due-date/add.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zone-policy-due-date/edit": {
      "filePath": "_home/zone-settings/zone-policy-due-date/edit.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zones/add": {
      "filePath": "_home/zone-settings/zones/add.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zones/edit": {
      "filePath": "_home/zone-settings/zones/edit.tsx",
      "parent": "/_home"
    },
    "/_home/message-templates/email/": {
      "filePath": "_home/message-templates/email/index.tsx",
      "parent": "/_home"
    },
    "/_home/message-templates/sms/": {
      "filePath": "_home/message-templates/sms/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/commodity-rates/": {
      "filePath": "_home/meter-connection-settings/commodity-rates/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/connection-status/": {
      "filePath": "_home/meter-connection-settings/connection-status/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/connection-type/": {
      "filePath": "_home/meter-connection-settings/connection-type/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-reader/": {
      "filePath": "_home/meter-connection-settings/meter-reader/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-size-rates/": {
      "filePath": "_home/meter-connection-settings/meter-size-rates/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-size/": {
      "filePath": "_home/meter-connection-settings/meter-size/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-status/": {
      "filePath": "_home/meter-connection-settings/meter-status/index.tsx",
      "parent": "/_home"
    },
    "/_home/system-config/announcement/": {
      "filePath": "_home/system-config/announcement/index.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/billing-user-info/": {
      "filePath": "_home/user-role-management/billing-user-info/index.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/department/": {
      "filePath": "_home/user-role-management/department/index.tsx",
      "parent": "/_home"
    },
    "/_home/user-role-management/position/": {
      "filePath": "_home/user-role-management/position/index.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/books-zone/": {
      "filePath": "_home/zone-settings/books-zone/index.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zone-connection-rates/": {
      "filePath": "_home/zone-settings/zone-connection-rates/index.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zone-policy-due-date/": {
      "filePath": "_home/zone-settings/zone-policy-due-date/index.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zones/": {
      "filePath": "_home/zone-settings/zones/index.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-reader/edit/$id": {
      "filePath": "_home/meter-connection-settings/meter-reader/edit.$id.tsx",
      "parent": "/_home"
    },
    "/_home/meter-connection-settings/meter-size/edit/$id": {
      "filePath": "_home/meter-connection-settings/meter-size/edit.$id.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/books-zone/edit/$id": {
      "filePath": "_home/zone-settings/books-zone/edit.$id.tsx",
      "parent": "/_home"
    },
    "/_home/zone-settings/zone-connection-rates/edit/$id": {
      "filePath": "_home/zone-settings/zone-connection-rates/edit.$id.tsx",
      "parent": "/_home"
    }
  }
}
ROUTE_MANIFEST_END */
